export default 
[
  {
    id: 1, 
    nome: 'Português',
    simbolo: 'pt-Br',
    imagem: 'img/acesso/atalhos/pt-BR.png',
    labels: {
      escolhaIdioma: "Escolha o seu idioma",
      pessoaFisica: "Pessoa Física",
      pessoaFisicaEstrangeira: "Pessoa Física (Estrangeira)",
      pessoaJuridica: "Pessoa Jurídica",
      proximo: "Avançar",
      para: "para",
      inscricao: "inscrição",
      doacao: "doação",
      email: "E-mail",
      salvar: "Salvar",
      inscrever: "Inscrever",
      doar: "Doar",
      inscricaoCase: "Inscrição",
      voltar: "Voltar",
      informacoesDoacao: "Informações doação",
      metodolodiaCurso: "Metodologia\\Programação",
      dataInicioInscricao: "Data início inscrição",
      dataFimInscricao: "Data fim inscrição",
      dataInicioCurso: "Data início",
      dataFimCurso: "Data fim",
      parcelas: "Nº parcelas",
      valorParcela: "Valor R$ parcela",
      categorias: "Categorias",
      valorCategorias: "Valor (R$)",
      informacaoCurso: "Informações",
      observacoesCurso: "Observações",
      justificativaCurso: "Justificativa",
      objetivosCurso: "Objetivos",
      infraestruturaCurso: "Infraestrutura",
      ementaCurso: "Ementa\\Disciplinas", 
      preRequisitoCurso: "Pré-requisito",
      publicoCurso: "Público-alvo",
      valorCategoriasCurso: "Valores e categorias para inscrição",
      formasPagamentoCurso: "Formas de pagamento",
      devolucaoCurso: "Devolução de inscrição",
      localCurso: "Local",
      duracaoCurso: "Duração",
      areaConhecimentoCurso: "Área do conhecimento",
      outrasInformacoes: "Outras informações",
      pagar: "Pagar",
      contatoProvedor: "Entrando em contato com o provedor. Aguarde...",
      pagamentoRecebidoDia: "Pagamento recebido com sucesso no dia",
      visitarSite: "Visitar site",
      tituloSiteDoacao: "da doação",
      tituloSiteCurso: "do curso",
      tituloSiteEvento: "do evento",
      perguntaInscricao: "pergunta",
      isentoInscricao: "isento",
      nomeInscricao: "Nome",
      enderecoInscricao: "Endereço",
      numeroInscricao: "Número",
      complementoInscricao: "Complemento",
      cidadeInscricao: "Cidade",
      telefoneInscricao: "Telefone",
      celularInscricao: "Celular",
      dataNascimentoInscricao: "Data de nascimento",
      emailInscricao: "E-mail",
      questionarioInscricao: "Questionário",
      simInscricao: "Sim",
      naoInscricao: "Não",
      categoriasInscricao: "Categorias de inscrição",
      valorCategoriaInscricao: "Valor (R$)",
      valorMinimoInscricao: "Valor mínimo",
      valorMaximoInscricao: "Valor máximo",
      meioPagamentoInscricao: "Meio de pagamentos",
      arquivosInscricao: "Arquivos",
      arquivosEnviadosInscricao: "Arquivos enviados",
      nenhumArquivoEncontradoInscricao: "Nenhum arquivo encontrado.",
      adicionarMaisArquivosInscricao: "Adicionar mais arquivos",
      obrigatorioInscricao: " obrigatório",
      perguntasObrigatorias: "As perguntas que estão indicadas com um asterisco vermelho é de resposta obrigatória. Responda o questionário e tente novamente.",
      anexarPeloMenosUmArquivo: "É necessário anexar pelo menos um arquivo ",
      salvaSucesso: "salva com sucesso",
      erroSalvar: "Erro ao salvar a",
      erroGetNetInternacional: "Problema no processamento do pagamento pelo crédito internacional GetNet",
      erroPayPalEstrangeiro: "Problema no processamento do pagamento pelo PayPal",
      erroCamposObrigatorios: "Há campos que são obrigatórios e não foram prenchidos, por favor confira os campos em vermelho.",
      valorEntre: '"Valor" deve estar entre ',
      valorMaiorIgual: '"Valor" deve ser maior ou igual a ',
      valorMenorIgual: '"Valor" deve ser menor ou igual a ',
      necessarioAnexarPeloMenos: 'É necessário anexar pelo menos ',
      permitidoAnexarMax: 'É permitido anexar no máximo ',
      arquivos: ' arquivo(s) ',
      outroValorInscricao: 'outro valor',
      documentoInsctricao: 'Documento',
      cepBuscaInscricao: 'CEP (busca automática)',
      bairroInscricao: 'Bairro',
      estadoInscricao: 'Estado',
      habilitarRecorrencia: 'Habilitar recorrência mensal deste pagamento',
      copiaColaPIX: "Pix copia e cola copiado com sucesso.",
      pagamentoRecebidoPagSeguro: "Pagamento recebido com sucesso e está sendo processado pelo PagSeguro.",
      problemaPagamentoPagSeguro: "Problema no processamento do pagamento pelo PagSeguro.",
      problemaGetNetBoleto: "Problema no processamento do pagamento pelo boleto GetNet",
      problemaGetNetCredito: "Problema no processamento do pagamento pelo crédito GetNet",
      problemaGetNetDebito: "Problema no processamento do pagamento pelo débito GetNet",
      problemaPagamentoPIX: "Problema no processamento do pagamento pelo Pix",
      problemaBoletoPopUp: "Erro ao gerar boleto, tente novamente. * verifique se houve um bloqueio de pop-up pelo navegador. Se sim, dê a permissão e tente novamente.",
      pagamentoProcessandoPayPal: "Pagamento recebido e está sendo processado pelo PayPal.",
      pagamentoReijeitadoPayPal: "Pagamento rejeitado pelo PayPal. Tente pagar novamente.",
    }
  },
  {
    id: 2,
    nome: 'Inglês',
    simbolo: 'en',
    imagem: 'img/acesso/atalhos/en.png',
    labels: {
      escolhaIdioma: "Choose your language",
      pessoaFisica: "Individual",
      pessoaFisicaEstrangeira: "Individual (Foreign)",
      pessoaJuridica: "Legal Entity",
      proximo: "Next",      
      para: "for",
      inscricao: "registration",
      doacao: "donation",
      email: "E-mail",
      salvar: "Save",
      inscrever: "Register",
      doar: "Donate",
      inscricaoCase: "Registration",
      voltar: "Back",
      informacoesDoacao: "Donation information",
      metodolodiaCurso: "Methodology\\Programming",
      dataInicioInscricao: "Registration start date",
      dataFimInscricao: "Registration end date",
      dataInicioCurso: "Start date",
      dataFimCurso: "End date",
      parcelas: "Number of installments",
      valorParcela: "Installment value in R$",
      categorias: "Categories",
      valorCategorias: "Value (R$)",
      informacaoCurso: "Information",
      observacoesCurso: "Observations",
      justificativaCurso: "Justification",
      objetivosCurso: "Objectives",
      infraestruturaCurso: "Infrastructure",
      ementaCurso: "Syllabus\\Subjects",
      preRequisitoCurso: "Prerequisite",
      publicoCurso: "Target audience",
      valorCategoriasCurso: "Values ​​and categories for registration",
      formasPagamentoCurso: "Payment methods",
      devolucaoCurso: "Refund of registration",
      localCurso: "Location",
      duracaoCurso: "Duration",
      areaConhecimentoCurso: "Area of ​​knowledge",
      outrasInformacoes: "Other information",
      pagar: "Pay",
      contatoProvedor: "Contacting the provider. Please wait...",
      pagamentoRecebidoDia: "Payment received successfully on the day",
      visitarSite: "Visit website",
      tituloSiteDoacao: "of the donation",
      tituloSiteCurso: "of the course",
      tituloSiteEvento: "of the event",
      perguntaInscricao: "question",
      isentoInscricao: "exempt",
      nomeInscricao: "Full name",
      enderecoInscricao: "Address",
      numeroInscricao: "Number",
      complementoInscricao: "Complement",
      cidadeInscricao: "City",
      telefoneInscricao: "Telephone",
      celularInscricao: "Cellphone",
      dataNascimentoInscricao: "Date of birth",
      emailInscricao: "E-mail",
      questionarioInscricao: "Questionnaire",
      simInscricao: "Yes",
      naoInscricao: "No",
      categoriasInscricao: "Registration categories",
      valorCategoriaInscricao: "Value (R$)",
      valorMinimoInscricao: "Minimum value",
      valorMaximoInscricao: "Maximum value",
      meioPagamentoInscricao: "Payment method",
      arquivosInscricao: "Files",
      arquivosEnviadosInscricao: "Files uploaded",
      nenhumArquivoEncontradoInscricao: "No files found.",
      adicionarMaisArquivosInscricao: "Add more files",
      obrigatorioInscricao: " required",
      perguntasObrigatorias: "The questions indicated with a red asterisk are mandatory. Answer the questionnaire and try again.",
      anexarPeloMenosUmArquivo: "It is necessary to attach at least one file",
      salvaSucesso: "saves successfully",
      erroSalvar: "Error saving the",
      erroGetNetInternacional: "Problem processing payment by GetNet international credit",
      erroPayPalEstrangeiro: "Problem processing payment by PayPal",
      erroCamposObrigatorios: "There are fields that are mandatory and have not been filled in, please check the fields in red.",
      valorEntre: '"Value" must be between ',
      valorMaiorIgual: '"Value" must be greater than or equal to ',
      valorMenorIgual: '"Value" must be less than or equal to ',
      necessarioAnexarPeloMenos: 'It is necessary to attach at least ',
      permitidoAnexarMax: 'It is allowed to attach a maximum of ',
      arquivos: ' file(s) ',
      outroValorInscricao: 'other value',
      documentoInsctricao: 'Document',
      cepBuscaInscricao: 'CEP (automatic search)',
      bairroInscricao: 'Neighborhood',
      estadoInscricao: 'State',
      habilitarRecorrencia: 'Enable monthly recurrence of this payment',
      copiaColaPIX: "Pix copy and paste copied successfully.",
      pagamentoRecebidoPagSeguro: "Payment received successfully and is being processed by PagSeguro.",
      problemaPagamentoPagSeguro: "Problem processing payment by PagSeguro.",
      problemaGetNetBoleto: "Problem processing payment by GetNet boleto",
      problemaGetNetCredito: "Problem processing payment by GetNet credit",
      problemaGetNetDebito: "Problem processing payment by GetNet debit",
      problemaPagamentoPIX: "Problem processing payment via Pix",
      problemaBoletoPopUp: "Error generating boleto, try again. * check if the pop-up was blocked by the browser. If so, give permission and try again.",
      pagamentoProcessandoPayPal: "Payment received and is being processed by PayPal.",
      pagamentoReijeitadoPayPal: "Payment rejected by PayPal. Please try to pay again.",
    }
  },
  {
    id: 3,
    nome: 'Espanhol',
    simbolo: 'es',
    imagem: 'img/acesso/atalhos/es.png',
    labels: {
      escolhaIdioma: "Elige tu idioma",
      pessoaFisica: "Individuo",
      pessoaFisicaEstrangeira: "Individuo (Extranjero)",
      pessoaJuridica: "Persona Jurídica",
      proximo: "Siguiente",
      para: "para",
      inscricao: "registro",
      doacao: "donación",
      email: "Correo electrónico",
      salvar: "Guardar",
      inscrever: "Regístrate",
      doar: "Donar",
      inscricaoCase: "Inscripción",
      voltar: "Volver",
      informacoesDoacao: "Información de donación",
      metodolodiaCurso: "Metodología\\Programación",
      dataInicioInscricao: "Fecha de inicio de registro",
      dataFimInscricao: "Fecha de finalización del registro",
      dataInicioCurso: "Fecha de inicio",
      dataFimCurso: "Fecha de finalización",
      parcelas: "Nº cuotas",
      valorParcela: "Valor R$ cuota",
      categorias: "Categorías",
      valorCategorias: "Valor (R$)",
      informacaoCurso: "Información",
      observacoesCurso: "Observaciones",
      justificativaCurso: "Justificación",
      objetivosCurso: "Objetivos",
      infraestruturaCurso: "Infraestructura",
      ementaCurso: "Plan de estudios\\Asignaturas",
      preRequisitoCurso: "Requisito previo",
      publicoCurso: "Público objetivo",
      valorCategoriasCurso: "Valores y categorías para registro",
      formasPagamentoCurso: "Métodos de pago",
      devolucaoCurso: "Devolución de inscripción",
      localCurso: "Local",
      duracaoCurso: "Duración",
      areaConhecimentoCurso: "Área de conocimiento",
      outrasInformacoes: "Otra información",
      pagar: "Pagar",
      contatoProvedor: "Contactando al proveedor. Espere por favor...",
      pagamentoRecebidoDia: "Pago recibido exitosamente ese día",
      visitarSite: "Visitar sitio web",
      tituloSiteDoacao: "de la donación",
      tituloSiteCurso: "del curso",
      tituloSiteEvento: "del evento",
      perguntaInscricao: "pregunta",
      isentoInscricao: "exento",
      nomeInscricao: "Nombre completo",
      enderecoInscricao: "Dirección",
      numeroInscricao: "Número",
      complementoInscricao: "Complemento",
      cidadeInscricao: "Ciudad",
      telefoneInscricao: "Teléfono",
      celularInscricao: "Teléfono celular",
      dataNascimentoInscricao: "Fecha de nacimiento",
      emailInscricao: "Correo electrónico",
      questionarioInscricao: "Cuestionario",
      simInscricao: "Sí",
      naoInscricao: "No",
      categoriasInscricao: "Categorías de registro",
      valorCategoriaInscricao: "Valor (R$)",
      valorMinimoInscricao: "Valor mínimo",
      valorMaximoInscricao: "Valor máximo",
      meioPagamentoInscricao: "Medio de pagos",
      arquivosInscricao: "Archivos",
      arquivosEnviadosInscricao: "Archivos enviados",
      nenhumArquivoEncontradoInscricao: "No se encontraron archivos.",
      adicionarMaisArquivosInscricao: "Agregar más archivos",
      obrigatorioInscricao: " requerido",
      perguntasObrigatorias: "Las preguntas indicadas con un asterisco rojo son obligatorias. Responde el cuestionario y vuelve a intentarlo.",
      anexarPeloMenosUmArquivo: "Debes adjuntar al menos un archivo",
      salvaSucesso: "guardado exitosamente",
      erroSalvar: "Error al guardar en",
      erroGetNetInternacional: "Problema al procesar el pago del crédito internacional GetNet",
      erroPayPalEstrangeiro: "Problema al procesar el pago del PayPal",
      erroCamposObrigatorios: "Hay campos que son obligatorios y no han sido completados, por favor marque los campos en rojo.",
      valorEntre: 'El "valor" debe estar entre ',
      valorMaiorIgual: '"Valor" debe ser mayor o igual a ',
      valorMenorIgual: 'El "valor" debe ser menor o igual que ',
      necessarioAnexarPeloMenos: 'Es necesario adjuntar al menos ',
      permitidoAnexarMax: 'Se permiten anexos máximos ',
      arquivos: ' archivo(s) ',
      outroValorInscricao: 'otro valor',
      documentoInsctricao: 'Documento',
      cepBuscaInscricao: 'CEP (búsqueda automática)',
      bairroInscricao: 'Barrio',
      estadoInscricao: 'Estado',
      habilitarRecorrencia: 'Habilitar la recurrencia mensual de este pago',
      copiaColaPIX: "Pix copiar y pegar copiada exitosamente.",
      pagamentoRecebidoPagSeguro: "Pago recibido exitosamente y está siendo procesado por PagSeguro.",
      problemaPagamentoPagSeguro: "Problema al procesar el pago a través de PagSeguro.",
      problemaGetNetBoleto: "Problema al procesar el pago mediante el boleto GetNet",
      problemaGetNetCredito: "Problema procesando el pago del crédito GetNet",
      problemaGetNetDebito: "Problema al procesar el pago de débito GetNet",
      problemaPagamentoPIX: "Problema al procesar el pago a través de Pix",
      problemaBoletoPopUp: "Error al generar el boleto, inténtelo de nuevo. * verifique si el navegador bloqueó la ventana emergente. Si es así, dé permiso e intente nuevamente.",
      pagamentoProcessandoPayPal: "Pago recibido y siendo procesado por PayPal.",
      pagamentoReijeitadoPayPal: "Pago rechazado por PayPal. Intente pagar nuevamente.",  
    }
  },
  {
    id: 4,
    nome: 'Francês',
    simbolo: 'fr',
    imagem: 'img/acesso/atalhos/fr.png',
    labels: {
      escolhaIdioma: "Choisissez votre langue",
      pessoaFisica: "Particulier",
      pessoaFisicaEstrangeira: "Individu (étranger)",
      pessoaJuridica: "Entité juridique",
      proximo: "Suivant",
      para: "pour",
      inscricao: "inscription",
      doacao: "donation",
      email: "E-mail",
      salvar: "Enregistrer",
      inscrever: "S'inscrire",
      doar: "Faire un don",
      inscricaoCase: "Inscription",
      voltar: "Retour",
      informacoesDoacao: "Informations sur les dons",
      metodolodiaCurso: "Méthodologie\\Programmation",
      dataInicioInscricao: "Date de début d'inscription",
      dataFimInscricao: "Date de fin d'inscription",
      dataInicioCurso: "Date de début",
      dataFimCurso: "Date de fin",
      parcelas: "Nombre de versements",
      valorParcela: "Valeur du versement R$",
      categorias: "Catégories",
      valorCategorias: "Valeur (R$)",
      informacaoCurso: "Information",
      observacoesCurso: "Observations",
      justificativaCurso: "Justification",
      objetivosCurso: "Objectifs",
      infraestruturaCurso: "Infrastructure",
      ementaCurso: "Syllabus\\Sujets",
      preRequisitoCurso: "Prérequis",
      publicoCurso: "Public cible",
      valorCategoriasCurso: "Valeurs et catégories pour l'inscription",
      formasPagamentoCurso: "Modes de paiement",
      devolucaoCurso: "Retour d'inscriptionn",
      localCurso: "Local",
      duracaoCurso: "Durée",
      areaConhecimentoCurso: "Domaine de connaissance",
      outrasInformacoes: "Autres informations",
      pagar: "Payer",
      contatoProvedor: "Contacter le fournisseur. Veuillez patienter...",
      pagamentoRecebidoDia: "Paiement reçu avec succès le jour même",
      visitarSite: "Visiter le site Web",
      tituloSiteDoacao: "du don",
      tituloSiteCurso: "du cours",
      tituloSiteEvento: "de l'événement",
      perguntaInscricao: "question",
      isentoInscricao: "exonéré",
      nomeInscricao: "Nom complet",
      enderecoInscricao: "Adresse",
      numeroInscricao: "Numéro",
      complementoInscricao: "Complément",
      cidadeInscricao: "Ville",
      telefoneInscricao: "Téléphone",
      celularInscricao: "Téléphone portable",
      dataNascimentoInscricao: "Date de naissance",
      emailInscricao: "Email",
      questionarioInscricao: "Questionnaire",
      simInscricao: "Oui",
      naoInscricao: "Non",
      categoriasInscricao: "Catégories d'inscription",
      valorCategoriaInscricao: "Valeur (R$)",
      valorMinimoInscricao: "Valeur minimale",
      valorMaximoInscricao: "Valeur maximale",
      meioPagamentoInscricao: "Moyen de paiement",
      arquivosInscricao: "Fichiers",
      arquivosEnviadosInscricao: "Fichiers envoyés",
      nenhumArquivoEncontradoInscricao: "Aucun fichier trouvé.",
      adicionarMaisArquivosInscricao: "Ajouter plus de fichiers",
      obrigatorioInscricao: " obligatoire",
      perguntasObrigatorias: "Les questions signalées par un astérisque rouge sont obligatoires. Répondez au questionnaire et réessayez.",
      anexarPeloMenosUmArquivo: "Vous devez joindre au moins un fichier",
      salvaSucesso: "enregistrer avec succès",
      erroSalvar: "Erreur lors de l'enregistrement dans",
      erroGetNetInternacional: "Problème lors du traitement du paiement pour le crédit international GetNet",
      erroPayPalEstrangeiro: "Problème lors du traitement du paiement pour le PayPal",
      erroCamposObrigatorios: "Certains champs sont obligatoires et n'ont pas été remplis, veuillez cocher les champs en rouge.",
      valorEntre: '"La valeur" doit être comprise entre ',
      valorMaiorIgual: '"Valeur" doit être supérieure ou égale à ',
      valorMenorIgual: '"Valeur" doit être inférieure ou égale à ',
      necessarioAnexarPeloMenos: 'Il faut attacher au moins ',
      permitidoAnexarMax: "Le nombre maximum d'ajouts est autorisé",
      arquivos: ' fichier(s) ',
      outroValorInscricao: 'autre valeur',
      documentoInsctricao: 'Document',
      cepBuscaInscricao: 'CEP (recherche automatique)',
      bairroInscricao: 'Quartier',
      estadoInscricao: 'Statut',
      habilitarRecorrencia: 'Activer la récurrence mensuelle de ce paiement',
      copiaColaPIX: "Le copier-coller du Pix a été copié avec succès.",
      pagamentoRecebidoPagSeguro: "Paiement reçu avec succès et en cours de traitement par PagSeguro.",
      problemaPagamentoPagSeguro: "Problème lors du traitement du paiement via PagSeguro.",
      problemaGetNetBoleto: "Problème lors du traitement du paiement via GetNet boleto",
      problemaGetNetCredito: "Problème de traitement du paiement pour le crédit GetNet",
      problemaGetNetDebito: "Problème lors du traitement du paiement par débit GetNet",
      problemaPagamentoPIX: "Problème lors du traitement du paiement via Pix",
      problemaBoletoPopUp: "Erreur lors de la génération du boleto, réessayez. * Vérifiez si le navigateur a bloqué la pop-up. Si c'est le cas, donnez l'autorisation et réessayez.",
      pagamentoProcessandoPayPal: "Paiement reçu et est en cours de traitement par PayPal.",
      pagamentoReijeitadoPayPal: "Paiement rejeté par PayPal. Veuillez réessayer de payer.",  
    }
  },
  {
    id: 5,
    nome: 'Italiano',
    simbolo: 'it',
    imagem: 'img/acesso/atalhos/it.png',
    labels: {
      escolhaIdioma: "Scegli la tua lingua",
      pessoaFisica: "Individuo",
      pessoaFisicaEstrangeira: "Individuo (straniero)",
      pessoaJuridica: "Persona giuridica",
      proximo: "Avanti",
      para: "per la",
      inscricao: "registrazione",
      doacao: "donazione",
      email: "E-mail",
      salvar: "Salva",
      inscrever: "Registrati",
      doar: "Donare",
      inscricaoCase: "Registrazione",
      voltar: "Ritorna",
      informacoesDoacao: "Informazioni sulle donazioni",
      metodolodiaCurso: "Metodologia\\Programmazione",
      dataInicioInscricao: "Data di inizio registrazionen",
      dataFimInscricao: "Data di fine registrazione",
      dataInicioCurso: "Data di inizio",
      dataFimCurso: "Data di fine",
      parcelas: "N. rate",
      valorParcela: "Rata di valore R$",
      categorias: "Categorie",
      valorCategorias: "Valore (R$)",
      informacaoCurso: "Informazioni",
      observacoesCurso: "Osservazioni",
      justificativaCurso: "Giustificazione",
      objetivosCurso: "Obiettivi",
      infraestruturaCurso: "Infrastrutture",
      ementaCurso: "Programma di studio\\Materie",
      preRequisitoCurso: "Prerequisito",
      publicoCurso: "Pubblico target",
      valorCategoriasCurso: "Valori e categorie per la registrazione",
      formasPagamentoCurso: "Metodi di pagamento",
      devolucaoCurso: "Restituzione della registrazione",
      localCurso: "Locale",
      duracaoCurso: "Durata",
      areaConhecimentoCurso: "Area della conoscenza",
      outrasInformacoes: "Altre informazioni",
      pagar: "Paga",
      contatoProvedor: "Sto contattando il provider. Attendi prego...",
      pagamentoRecebidoDia: "Pagamento ricevuto con successo il giorno stesso",
      visitarSite: "Visita il sito web",
      tituloSiteDoacao: "della donazione",
      tituloSiteCurso: "del corso",
      tituloSiteEvento: "dell'evento",
      perguntaInscricao: "domanda",
      isentoInscricao: "esente",
      nomeInscricao: "Nome completo",
      enderecoInscricao: "Indirizzo",
      numeroInscricao: "Numero",
      complementoInscricao: "Complemento",
      cidadeInscricao: "Città",
      telefoneInscricao: "Telefono",
      celularInscricao: "Cellulare",
      dataNascimentoInscricao: "Data di nascita",
      emailInscricao: "Email",
      questionarioInscricao: "Questionario",
      simInscricao: "Sì",
      naoInscricao: "No",
      categoriasInscricao: "Categorie di registrazione",
      valorCategoriaInscricao: "Valore (R$)",
      valorMinimoInscricao: "Valore minimo",
      valorMaximoInscricao: "Valore massimo",
      meioPagamentoInscricao: "Mezzo di pagamenti",
      arquivosInscricao: "File",
      arquivosEnviadosInscricao: "File inviati",
      nenhumArquivoEncontradoInscricao: "Nessun file trovato.",
      adicionarMaisArquivosInscricao: "Aggiungi più file",
      obrigatorioInscricao: " richiesto",
      perguntasObrigatorias: "Le domande indicate con un asterisco rosso sono obbligatorie. Rispondi al questionario e riprova.",
      anexarPeloMenosUmArquivo: "Devi allegare almeno un file",
      salvaSucesso: "salvataggio riuscito",
      erroSalvar: "Errore durante il salvataggio in",
      erroGetNetInternacional: "Problema nell'elaborazione del pagamento per il credito internazionale GetNet",
      erroPayPalEstrangeiro: "Problema nell'elaborazione del pagamento per il PayPal",
      erroCamposObrigatorios: "Ci sono campi obbligatori che non sono stati compilati, controlla i campi in rosso.",
      valorEntre: '"Il valore" deve essere compreso tra ',
      valorMaiorIgual: '"Value" deve essere maggiore o uguale a ',
      valorMenorIgual: '"Valore" deve essere minore o uguale a ',
      necessarioAnexarPeloMenos: 'È necessario allegare almeno ',
      permitidoAnexarMax: 'È consentito il numero massimo di accodamenti ',
      arquivos: ' file(i) ',
      outroValorInscricao: 'altro valore',
      documentoInsctricao: 'Documento',
      cepBuscaInscricao: 'CEP (ricerca automatica)',
      bairroInscricao: 'Quartiere',
      estadoInscricao: 'Stato',
      habilitarRecorrencia: 'Abilita la ricorrenza mensile di questo pagamento',
      copiaColaPIX: "Pix copia e incolla copiato con successo.",
      pagamentoRecebidoPagSeguro: "Pagamento ricevuto con successo ed è in fase di elaborazione da PagSeguro.",
      problemaPagamentoPagSeguro: "Problema nell'elaborazione del pagamento tramite PagSeguro.",
      problemaGetNetBoleto: "Problema nell'elaborazione del pagamento tramite boleto GetNet",
      problemaGetNetCredito: "Problema nell'elaborazione del pagamento per il credito GetNet",
      problemaGetNetDebito: "Problema nell'elaborazione del pagamento con addebito GetNet",
      problemaPagamentoPIX: "Problema nell'elaborazione del pagamento tramite Pix",
      problemaBoletoPopUp: "Errore nella generazione del boleto, riprova. * controlla se il browser ha bloccato il pop-up. In tal caso, dai il permesso e riprova.",
      pagamentoProcessandoPayPal: "Pagamento ricevuto ed è in fase di elaborazione da PayPal.",
      pagamentoReijeitadoPayPal: "Pagamento rifiutato da PayPal. Prova a pagare di nuovo.",  
    }
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/solCursoEventoDoacaoTranslate.js